import { selectors } from './constants';
import 'element-closest-polyfill';

/**
 * Given an array of elements, filters them to ensure that we only
 * query within active and complete panels or the current panel. Useful for getFields, etc.
 *
 * @param {Element[]} elements - An array of elements
 * @param {Element} [context] - Optional element to include all fields within the current panel
 * @returns {string[]}
 */
export default function filterActiveCompleteSteps(elements, context) {
  const activeOrComplete = [selectors.active, selectors.complete].join();
  const contextStep = context && context.closest(selectors.step);

  return elements.filter(
    element => {
      const step = element.closest(selectors.step);
      return !step || step === contextStep || step.matches(activeOrComplete);
    }
  );
}
